import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import IconDate from "../../component/SvgIcons/IconDate";
import IconDateActive from "../../component/SvgIcons/IconDateActive";
import IconFilter from "../../component/SvgIcons/IconFilter";
import IconPlus from "../../component/SvgIcons/IconPlus";
import IconSearchTable from "../../component/SvgIcons/IconSearchTable";
import DateFilter from "../../component/DateFilter/DateFilter";
import api from "../../services/axios";
import useBootstrapTooltip from "../../services/useBootstrapTooltip";
import AudioPlayer from "./AudioPlayer";
import { useAuth } from "../../context/AuthContext";
import { AnimatePresence, motion } from "framer-motion";
import CustomDropdown from "../../component/CustomDropdown";
import numberOptions from "../../component/NumberOptions/numberOptionsdata";
import "./style.css";
import utils from "../../utils/utils";
import IconMinimize from "../../component/SvgIcons/IconMinimize";
import IconArrowUp from "../../component/SvgIcons/IconArrowUp";
const Recording =
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3";

export default function TicketsList() {
  const selectAllRef = useRef();
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");    
  const [currentPage, setCurrentPage] = useState(1);
  const [isCustomDateFilter, setIsCustomDateFilter] = useState(false);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [expandedTickets, setExpandedTickets] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [agents, setAgents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(
    window.innerWidth >= 1920 ? 16 : 10
  );
  const { authUser } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    utils.saveRecentSearch("Ticket List", "/tickets-list");
  }, []);  
  useEffect(() => {
    const fetchTickets = async () => {
      setIsLoading(true);
      try {
        let payload = {};
        // if (authUser.isAdmin) {
        //   payload = { isAdmin: true };
        // } else {
        //   payload = {
        //     isAdmin: false,
        //     Code: authUser.Code,
        //     Agents_Company: authUser?.Agents_Company,
        //   };
        // }
        const res = await api.post("/list_ticket", payload);

        if (res.data.data && Array.isArray(res.data.data)) {
          setRowData(res.data.data);
        } else {
          setRowData([]);
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch tickets:", error);
      }finally {
        setIsLoading(false);
      }
    };

    fetchTickets();
    const fetchAgents = async () => {
      try {
        const res = await api.post("/list_agent");
        if (res.data && Array.isArray(res.data.data)) {
          setAgents(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching agents:", error);
      }
    };

    fetchAgents();
  }, []);
   const getAgentName = (Code) => {
    const found = agents.find((agent) => agent.Code === Number(Code));
    return found ? found.Agent_Name : `User ${Code}`;
  };
  // ✅ Handle row selection
const handleRowSelect = (rowId) => {
  if (selectedRows.includes(rowId)) {
    setSelectedRows([]); // Deselect if same row clicked again
  } else {
    setSelectedRows([rowId]); // Replace with the new selected row
  }
};
  // ✅ Handle "Select All"
  const handleSelectAll = () => {
  const pageRowIds = paginatedData.map((row) => row.ticketNo);  // <-- fix here
  const allSelected = pageRowIds.every((id) => selectedRows.includes(id));
  let updatedSelected = [];
  if (allSelected) {
    // Unselect all rows on this page
    updatedSelected = selectedRows.filter((id) => !pageRowIds.includes(id));
  } else {
    // Select all rows on this page
    updatedSelected = [...new Set([...selectedRows, ...pageRowIds])];
  }
  setSelectedRows(updatedSelected);
  console.log("Updated selectedRows:", updatedSelected);
};

  // ✅ Handle Sorting
  const handleSort = (column) => {
  setSortConfig((prevConfig) => {
    if (prevConfig.key === column) {
      return {
        ...prevConfig,
        direction: prevConfig.direction === "asc" ? "desc" : "asc",
      };
    } else {
      return {
        key: column,
        direction: "asc",
      };
    }
  });
};
  // ✅ Handle Search
  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (!selectAllRef.current) return;

    const pageRowIds = paginatedData.map((row) => row.Code);
    const selectedCount = pageRowIds.filter((id) =>
      selectedRows.includes(id)
    ).length;

    selectAllRef.current.indeterminate =
      selectedCount > 0 && selectedCount < pageRowIds.length;
  }, [selectedRows, rowData, currentPage]);

  const dataToFilter = isCustomDateFilter ? filteredTickets : rowData;
  
// Filter & sort tickets
const filteredData = dataToFilter
  .filter((row) => {
    if (!row || typeof row !== 'object') return false;
    return Object.values(row).some((value) => {
      if (value == null) return false;
      return value.toString().toLowerCase().includes(searchQuery.toLowerCase());
    });
  })
  .sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];
    if (aValue === undefined || bValue === undefined) return 0;
    const isNumber = !isNaN(aValue) && !isNaN(bValue);
    return isNumber
      ? (sortConfig.direction === 'asc' ? Number(aValue) - Number(bValue) : Number(bValue) - Number(aValue))
      : (sortConfig.direction === 'asc'
          ? String(aValue).localeCompare(String(bValue))
          : String(bValue).localeCompare(String(aValue)));
  });

// group filtered data first
const groupedData = useMemo(() => {
  const groups = {};
  filteredData.forEach(item => {
    if (!groups[item.Ticket_No]) groups[item.Ticket_No] = [];
    groups[item.Ticket_No].push(item);
  });
  return Object.entries(groups).map(([ticketNo, items]) => ({ ticketNo, items }));
}, [filteredData]);

const totalPages = Math.ceil(groupedData.length / itemsPerPage);

const paginatedData = groupedData.slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);


  // ✅ Initialize Bootstrap tooltips
  useBootstrapTooltip([paginatedData, currentPage]);
  // ✅ Handle page change
 const handlePageChange = (page) => {
  console.log("Page clicked:", page);
  if (page < 1 || page > totalPages) return;
  setCurrentPage(page);
};


  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    // Format: DD-MM-YYYY
    const formattedDate = date.toLocaleDateString("en-GB").replaceAll("/", "-");
    // Format: hh:mm AM/PM
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return `${formattedDate} ${formattedTime}`;
  };

  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };
  const truncateWords = (text = "", count = 4) => {
  const words = text.split(" ");
  return words.slice(0, count).join(" ") + (words.length > count ? "..." : "");
};
  const handlePeriodSelect = (periodLabel, startDate, endDate) => {
    if (startDate && endDate) {
      const sDate = normalizeStartDate(startDate);
      const eDate = normalizeEndDate(endDate);

      const filtered = rowData.filter((ticket) => {
        const createdDate = new Date(ticket.Create_Date_Time_Stamp);
        return createdDate >= sDate && createdDate <= eDate;
      });
      setFilteredTickets(filtered);
      setCurrentPage(1);
      setIsCustomDateFilter(true);
    } else {
      setFilteredTickets([]);
      setIsCustomDateFilter(false);
    }
  };
  // Set indeterminate state for header checkbox

  const normalizeStartDate = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  const normalizeEndDate = (date) => {
    const d = new Date(date);
    d.setHours(23, 59, 59, 999);
    return d;
  };


const toggleExpand = (ticketNo) => {
  setExpandedTickets((prev) => {
    const isExpanded = !!prev[ticketNo];
    // Collapse all if already expanded, else expand only this one
    return isExpanded ? {} : { [ticketNo]: true };
  });
};


  return (
    <div className="dashboard">
      <Header title subtitle="Tickets List" searchbar />
      <div className="center-content">
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <AnimatePresence mode="wait">
              <motion.div
                className="pagegap d-flex flex-column"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.4 }}
              >
                <h2 className="create-titles mb-0 d-flex align-items-center">
                  <DiamondsFour /> <span>Tickets</span>
                </h2>
                <div className="tabletopbar d-flex align-items-center gap-2 justify-content-between flex-column flex-md-row">
                  <div className="tablefilter d-flex align-items-center">
                    {authUser?.Agents_Company?.trim() ===
                      "Global Assist" && (
                      <Link to="/create-ticket" className="btn btngradiant">
                        <IconPlus /> Add Ticket
                      </Link>
                    )}
                    <DateFilter onPeriodSelect={handlePeriodSelect} />
                  </div>
                  <div className="d-flex align-items-center gap-3">
                    <div className="tablesearch position-relative">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search"
                        value={searchQuery}
                        onChange={handleSearch}
                      />
                      <span className="position-absolute">
                        <IconSearchTable />
                      </span>
                    </div>

                    <CustomDropdown
                      name="itemsPerPage"
                      options={numberOptions}
                      value={itemsPerPage.toString()}
                      onChange={(value) => {
                        const num = Number(value);
                        setItemsPerPage(num);
                        setCurrentPage(1);
                      }}
                      placeholder="Items Per Page"
                      className="items-per-page-dropdown"
                    />
                  </div>
                </div>
                <div className="tablespace">
                  <div className="table-responsive">
                    <table className="table table-hover my-0">
                      <thead className="thead-light">
                        <tr>
                          <th width="50" style={{ paddingRight: "5px" }}>
                            Sr. No
                          </th>
                          <th width="100">
                            {/* "Select All" Checkbox */}
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customCheckDisabled"
                              onChange={handleSelectAll}
                              checked={
                                paginatedData.length > 0 &&
                                paginatedData.every((row) =>
                                  selectedRows.includes(row.Ticket_No)
                                )
                              }
                            />
                            <div className="d-flex align-items-center">
                              {/* <label
                                className="tablecheckbox headercheckbox position-relative"
                                htmlFor="customCheckDisabled"
                              >
                                <div className="rounded-circle" />
                              </label> */}
                              <div className="d-flex align-items-center justify-content-between w-100">
                                <span>
                                  <IconDate /> Date & Time
                                </span>
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleSort("Create_Date_Time_Stamp")
                                  }
                                >
                                  <IconFilter />
                                </span>
                              </div>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Ticket No
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Ticket_No")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="150">
                            <div className="d-flex align-items-center justify-content-between">
                              Customer Name
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Customer_Name")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="150">
                            <div className="d-flex align-items-center justify-content-between">
                              Customer Code
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Customer_Code")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              User
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("User")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="100">
                            <div className="d-flex align-items-center justify-content-between">
                              Escalated To
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("escalated_to")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          <th width="150">
                            <div className="d-flex align-items-center justify-content-between">
                              Issue Type
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Issue_Details")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>

                          {authUser?.Agents_Company?.trim() === "Global Assist" && (
                            <th width="150">Recorded Call</th>
                          )}                          
                          <th width="80">
                            <div className="d-flex align-items-center justify-content-between">
                              Status
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleSort("Status_DisplayName")}
                              >
                                <IconFilter />
                              </span>
                            </div>
                          </th>
                          <th width="1" style={{ padding: 0 }}></th>
                        </tr>
                      </thead>
                     <tbody>
                     {isLoading ? (
                        <tr>
                          <td colSpan="10" className="text-center" style={{ padding: "30px" }}>
                            Loading tickets, please wait...
                          </td>
                        </tr>
                      ) :paginatedData.length > 0 ? (
                          paginatedData.map(({ ticketNo, items }, mainIndex) => {
                            const isExpanded = expandedTickets[ticketNo];
                            const latestItem = items[0];
                            const mainSerial = (currentPage - 1) * itemsPerPage + mainIndex + 1;
                          return (
                            <Fragment key={ticketNo}>
                              {/* Render the latest ticket row */}
                            <tr
                              key={latestItem.Call_Sr_No}
                              className={[
                                selectedRows.includes(latestItem.Ticket_No) ? "ticket-row selected-row" : "ticket-row",
                                expandedTickets[latestItem.Ticket_No] ? "expanded-row" : ""
                              ].join(" ")}                             
                              style={{ cursor: "pointer" }} 
                              onClick={() => {
                                navigate(`/view-ticket-history/${latestItem.Ticket_No}`);
                                window.scrollTo(0, 0);
                              }}>
                                <td className="text-center">
                                  <span>{mainSerial}</span>
                                </td>
                                <td>
                                  <figure className="d-flex align-items-center custom-control-label">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id={`customCheckDisabled-${ticketNo}`}
                                      checked={selectedRows.includes(ticketNo)}
                                      onChange={() => handleRowSelect(ticketNo)}
                                    />
                                    <label
                                      className="tablecheckbox position-relative"
                                      htmlFor={`customCheckDisabled-${ticketNo}`}
                                    >
                                      <p className="colorblack ticketcircle mb-0">
                                        {selectedRows.includes(ticketNo) ? <IconDateActive /> : <IconDate />}
                                        {formatDateTime(latestItem.Create_Date_Time_Stamp)}
                                      </p>
                                      <div className="rounded-circle" />
                                    </label>
                                  </figure>
                                </td>
                                <td>
                                  <p className="colorblack mb-0">
                                    {ticketNo}
                                  </p>
                                </td>
                                <td data-bs-toggle="tooltip" data-bs-placement="top" title={latestItem.Customer_Name || ""}>
                                {latestItem.Customer_Name ? (() => {
                                  const words = latestItem.Customer_Name.split(" ");
                                  return words.slice(0, 2).join(" ") + (words.length > 3 ? "..." : "");
                                })() : " "}
                                </td>
                                <td data-bs-toggle="tooltip" data-bs-placement="top" title={latestItem.Customer_Code || ""}>
                                {latestItem.Customer_Code ? (() => {
                                  const words = latestItem.Customer_Code.split(" ");
                                  return words.slice(0, 2).join(" ") + (words.length > 3 ? "..." : "");
                                })() : " "}
                              </td>
                                <td>
                                    {getAgentName(latestItem.User)}                              
                                </td>
                                <td>
                                  <p className="colorblack mb-0">
                                    {latestItem.escalated_to?.includes("FA") && (
                                      <img className="exgrid" src="../images/fa.svg" alt="FA" />
                                    )}
                                    {latestItem.escalated_to?.includes("GK") && (
                                      <img className="exgrid" src="../images/gk.svg" alt="GK" />
                                    )}
                                    {latestItem.escalated_to?.includes("Gulf") && (
                                      <img className="exgrid" src="../images/gf.svg" alt="GF" />
                                    )}
                                    {latestItem.escalated_to?.includes("Global Software") && (
                                      <img className="exgrid" src="../images/gs.svg" alt="GS" />
                                    )}
                                  </p>
                                </td>
                                <td
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title={stripHtml(latestItem.Issue_Details)}
                              >
                                {truncateWords(stripHtml(latestItem.Issue_Details), 4)}
                              </td>

                                {authUser?.Agents_Company?.trim() === "Global Assist" && (
                                  <td>
                                    <AudioPlayer url={Recording} />
                                  </td>
                                )}
                                <td align="right" width="90">
                                  <Link
                                    to={`/view-ticket-history/${latestItem.Ticket_No}`}
                                    className={`statusbtn ${latestItem.Status_Name?.toLowerCase().replace(/\s+/g, "-")}`}
                                  >
                                    {latestItem.Status_DisplayName}
                                  </Link>
                                </td>
                              {items.length > 1 ? (
                                  <td
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleExpand(latestItem.Ticket_No);
                                      handleRowSelect(latestItem.Ticket_No);
                                    }}
                                  >
                                    <img
                                      src="../images/downarrow.svg"
                                      width={30}
                                      alt="expand"
                                      style={{
                                        transform: expandedTickets[latestItem.Ticket_No] ? "rotate(180deg)" : "rotate(0deg)",
                                        transition: "transform 0.3s ease",
                                        opacity: expandedTickets[latestItem.Ticket_No] ? 1 : 0.3,
                                      }}
                                    />
                                  </td>
                                ) : <td></td>}

                              </tr>

                              {/* Expanded rows (older tickets) */}
                            {isExpanded && items.length > 1 && (
                            <tr key={`expanded-${ticketNo}`} className="expanded-row">
                              <td colSpan={10} className="p-0">
                                <div className="expanded-wrapper">
                                  <table className="table mb-0">
                                    <thead>
                                      <tr>
                                        <th>Sr. No</th>
                                        <th><IconDate/> Date</th>                                  
                                        <th>User</th>
                                        <th>Escalated To</th>
                                        <th>Issue Details</th>
                                        {authUser?.Agents_Company?.trim() === "Global Assist" && <th>Recording</th>}
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {items.slice(1).map((row, idx) => (
                                        <tr style={{ cursor: "pointer" }} key={`${ticketNo}-${idx}`}  onClick={() => navigate(`/view-ticket-history/${row.Ticket_No}`)}>
                                          <td className="text-center"> 
                                            {/* {(currentPage - 1) * itemsPerPage + idx + 1} */}
                                            {`${mainSerial}-${idx + 1}`}
                                            </td>
                                          <td>
                                              {selectedRows.includes(row.Ticket_No) ? <IconDateActive /> : <IconDate />}{" "}
                                              {formatDateTime(row.Create_Date_Time_Stamp)}                                            
                                          </td>
                                          <td>
                                            {getAgentName(row.User)}
                                          </td>
                                          <td>
                                              {row.escalated_to?.includes("FA") && <img className="exgrid" src="../images/fa.svg" alt="FA" />}
                                              {row.escalated_to?.includes("GK") && <img className="exgrid" src="../images/gk.svg" alt="GK" />}
                                              {row.escalated_to?.includes("Gulf") && <img className="exgrid" src="../images/gf.svg" alt="GF" />}
                                              {row.escalated_to?.includes("Global Software") && (
                                                <img className="exgrid" src="../images/gs.svg" alt="GS" />
                                              )}                                            
                                          </td>
                                          <td data-bs-toggle="tooltip" data-bs-placement="top" title={stripHtml(row.Issue_Details)}>
                                              {(() => {
                                                const text = stripHtml(row.Issue_Details);
                                                const words = text.split(" ");
                                                const truncated = words.slice(0, 4).join(" ");
                                                return truncated + (words.length > 4 ? "..." : "");
                                              })()}                                           
                                          </td>
                                          {authUser?.Agents_Company?.trim() === "Global Assist" && (
                                            <td onClick={(e) => e.stopPropagation()}>
                                              <AudioPlayer url={Recording} />
                                            </td>
                                          )}
                                          <td align="right" width="90">
                                            <Link
                                              to="#"
                                              className={`statusbtn ${row.Status_Name?.toLowerCase().replace(/\s+/g, "-")}`}
                                            >
                                              {row.Status_DisplayName}
                                            </Link>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                              )}
                            </Fragment>
                          );
                        })
                      ) : isCustomDateFilter ? (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No data found for the selected custom date range.
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center">
                            No data found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    </table>
                  </div>
                  {totalPages > 1 && (
                    <Pagination
                      totalPages={totalPages}
                      currentPage={currentPage}
                      handlePageChange={handlePageChange}
                    />
                  )}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
